const actionTypeIdentifier = "19BB7171-AB3F-495C-81CC-1CE039D14B10";

export const setDisputeHistoryLogsLoading = `SET-DISPUTE-HISTORY-LOGS-LOADING-${actionTypeIdentifier}`;
export const getDisputeHistoryLogs = `GET-DISPUTE-HISTORY-LOGS-${actionTypeIdentifier}`;
export const setDisputeHistoryPageSize = `SET-DISPUTE-HISTORY-PAGE-SIZE-${actionTypeIdentifier}`;
export const resetDisputeHistory = `RESET-DISPUTE-HISTORY-${actionTypeIdentifier}`;
export const setDisputeHistoryColSearchStr = `SET-DISPUTE-HISTORY-COL-SEARCH-${actionTypeIdentifier}`;
    